import { Minus, Plus } from 'lucide-react'
import { cn } from '../../lib/utils'

interface QuantityStepperProps {
  value: number
  onChange: (value: number) => void
  min?: number
  max?: number
  className?: string
}

export function QuantityStepper({
  value,
  onChange,
  min = 1,
  max = 99,
  className,
}: QuantityStepperProps) {
  const dec = () => onChange(Math.max(min, value - 1))
  const inc = () => onChange(Math.min(max, value + 1))

  return (
    <div
      className={cn(
        'inline-flex items-center rounded-xl border border-ink-200 bg-white',
        className
      )}
    >
      <button
        type="button"
        onClick={dec}
        disabled={value <= min}
        aria-label="decrease"
        className="flex size-10 items-center justify-center text-ink-600 disabled:opacity-40 hover:text-ink-900"
      >
        <Minus className="size-4" />
      </button>
      <span className="w-10 text-center font-semibold tabular-nums">{value}</span>
      <button
        type="button"
        onClick={inc}
        disabled={value >= max}
        aria-label="increase"
        className="flex size-10 items-center justify-center text-ink-600 disabled:opacity-40 hover:text-ink-900"
      >
        <Plus className="size-4" />
      </button>
    </div>
  )
}
